import { Yup } from 'cng-web-lib'

function makeValidationSchema() {
  return Yup.object({
    partyType: Yup.string()
      .required('Party Type is required'),
    partyIdentificationType: Yup.string()
      .required('Party Identification Type is required'),
    partyName: Yup.string()
      .required('Party Name is required')
      .max(70, 'Max 70 characters'),
    address1: Yup.string()
      .required('Address 1 is required')
      .max(256, 'Max 256 characters'),
    address2: Yup.string().nullable()
      .max(256, 'Max 256 characters'),
    address3: Yup.string().nullable()
      .max(256, 'Max 256 characters'),
    city: Yup.string().nullable()
      .max(35, 'Max 35 characters')
      .when('partyType', {
        is: (val) => val === 'CZ' || val === 'CN',
        then: Yup.string().required('City is required for Shipper/Consignee')
      }),
    country: Yup.string().nullable()
      .when('partyType', {
        is: (val) => val === 'CZ' || val === 'CN',
        then: Yup.string().required('Country is required for Shipper/Consignee')
      }),
    contactInfo: Yup.array().of(
      Yup.object({
        contactLevel: Yup.string().nullable(),
        contactName: Yup.string().nullable().max(256, 'Max 256 characters')
          .test('contactName-required', "This field is mandatory if Contact Level is 'Individual'", function(value) {
            return this.parent.contactLevel === 'IN' ? !!value && value.trim() !== '' : true
          }),
        telephoneNumber: Yup.string().nullable().max(512, 'Max 512 characters'),
        emailId: Yup.string().nullable().email('Invalid email').max(512, 'Max 512 characters'),
        url: Yup.string().nullable().max(512, 'Max 512 characters')
      })
    ).nullable()
  })
}

export default makeValidationSchema
